import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { relatedPagesTexts } from '../../shared/sharedMessages';
import { MIN_RELATED_PAGES, MAX_RELATED_PAGES } from '../../constants/sbConstants';

const SharedRelatedPagesComponent = ({
    itemSearch,
    LinksBlockComponent,
    dataTn,
    noBottomMargin,
}) => {
    const { appliedFilters, relatedPages } = itemSearch;
    if (appliedFilters && relatedPages && relatedPages.length >= MIN_RELATED_PAGES) {
        const { anchorTextPrefix, linksBlockTitle } = relatedPagesTexts(appliedFilters);

        if (!linksBlockTitle) {
            return null;
        }

        return (
            <LinksBlockComponent
                title={linksBlockTitle}
                anchorTextPrefix={anchorTextPrefix}
                links={relatedPages.slice(0, MAX_RELATED_PAGES)}
                dataTn={dataTn}
                noBottomMargin={noBottomMargin}
            />
        );
    }

    return null;
};

SharedRelatedPagesComponent.propTypes = {
    itemSearch: PropTypes.shape({
        appliedFilters: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                values: PropTypes.arrayOf(
                    PropTypes.shape({
                        displayName: PropTypes.string,
                    })
                ),
            })
        ),
        relatedPages: PropTypes.arrayOf(
            PropTypes.shape({
                anchorText: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            })
        ),
    }),
    LinksBlockComponent: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
    noBottomMargin: PropTypes.bool,
};

export const SharedRelatedPages = createFragmentContainer(SharedRelatedPagesComponent, {
    itemSearch: graphql`
        fragment SharedRelatedPages_itemSearch on ItemSearchQueryConnection {
            appliedFilters {
                name
                values {
                    displayName
                }
            }
            relatedPages {
                anchorText
                url
            }
        }
    `,
});
